import { Helmet } from "react-helmet-async";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import ClientJourneySection from "@/components/ClientJourneySection";
import MarketPartnerReveal from "@/components/MarketPartnerReveal";
import CaseStudiesSection from "@/components/CaseStudiesSection";
import { FeaturedProperties } from "@/components/FeaturedProperties";
import ExclusiveAccessCTA from "@/components/ExclusiveAccessCTA";
import VIPConsultationBanner from "@/components/VIPConsultationBanner";
import ServicesSection from "@/components/ServicesSection";
import { HeritageSection } from "@/components/HeritageSection";
import ResidencyVisaSection from "@/components/ResidencyVisaSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

const Index = () => {
  return (
    <>
      <Helmet>
        <title>Agota Estate | Luxury Real Estate Investment Across 14 Global Markets</title>
        <meta name="description" content="Your global real estate advisory partner. We guide property investments across Monaco, Dubai, London, Italy, Spain & 10 more markets — from first inquiry to key handover. €2M–€50M+." />
        <meta name="keywords" content="luxury real estate investment, global property advisory, Monaco property, Dubai penthouse, London mansion, real estate acquisition, UHNWI real estate, generational wealth, property investment guide" />
        <link rel="canonical" href="https://agotaestate.com" />
        <meta property="og:title" content="Agota Estate | Your Global Real Estate Investment Partner" />
        <meta property="og:description" content="We guide your property investment worldwide — connecting you with the best local brokerages across 14 global markets." />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "RealEstateAgent",
            "name": "Agota Estate",
            "description": "Global luxury real estate investment advisory — guiding clients from first inquiry to key handover across 14 international markets",
            "url": "https://agotaestate.com",
            "telephone": "+37060044499",
            "email": "ask@agotaestate.com",
            "areaServed": ["Monaco", "Dubai", "London", "Italy", "Spain", "Abu Dhabi", "KSA", "Hong Kong", "Macau", "USA", "France", "Australia", "Qatar", "Switzerland"],
            "priceRange": "€2,000,000 - €50,000,000+",
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Investment Advisory Services",
              "itemListElement": [
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Bespoke Property Sourcing" }},
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Cross-Border Investment Strategy" }},
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Local Partner Matching" }},
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Due Diligence & Negotiation" }},
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "White-Glove Concierge" }},
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Fiduciary Excellence" }}
              ]
            }
          })}
        </script>
      </Helmet>
      <main className="min-h-screen bg-background text-foreground">
        <Navbar />
        
        {/* 1. Hero — Purpose-driven with instant CTAs */}
        <HeroSection />
        
        {/* 2. Client Journey — How we guide you, step by step */}
        <ClientJourneySection />
        
        {/* 3. VIP Quick Contact — High-intent conversion point */}
        <VIPConsultationBanner />
        
        {/* 4. Market-Matched Partner Reveal — Select a market, meet your team */}
        <MarketPartnerReveal />
        
        {/* 5. Featured Properties — Proof of portfolio */}
        <FeaturedProperties />
        
        {/* 6. Investment Assessment — Primary lead capture funnel */}
        <ExclusiveAccessCTA />
        
        {/* 7. Services — Expertise detail */}
        <ServicesSection />
        
        {/* 8. Heritage — Trust & legacy */}
        <HeritageSection />
        
        {/* 9. Residency & Visa — Golden visa pathways */}
        <ResidencyVisaSection />
        
        {/* 10. Case Studies — Real journey proof */}
        <CaseStudiesSection />
        
        {/* 11. Testimonials — Social proof */}
        <TestimonialsSection />
        
        {/* 11. FAQ */}
        <FAQSection />
        
        {/* 12. Contact — Final conversion */}
        <ContactSection />
        
        <Footer />
      </main>
    </>
  );
};

export default Index;
